import { date, number, route, string, union } from "react-router-typesafe-routes";

export type PostGigType = NonNullable<ReturnType<typeof postGigParams.$deserializeSearchParams>["post_gig_type"]>;
export const postGigParams = route({
  searchParams: {
    return_to: string(),

    post_gig_date: date(),
    post_gig_type: union(["single", "schedule", "assign", "event"]),
    eventName: string(),
    // direct offer
    offer_pro: number(),
    offer_group: number(),
  },
});

export const postGigTypeLabelLookup: Record<PostGigType, string> = {
  single: "Post Shift",
  schedule: "Post Schedule",
  assign: "Assign Shift",
  event: "Create Event",
};
